<script lang="ts">
    import { MoneyModule } from "@modules/money/MoneyModule";
    import { marked } from "marked";
    import { container } from "tsyringe";

    export let text: string;

    const moneyModule = container.resolve(MoneyModule);
    const sanitizer = moneyModule.exports.htmlSanitizer;
</script>

{@html sanitizer
    .sanitize(marked.parse(text, { async: false }))
    .replace(/\s+$/g, "")}
